import { server_connection } from 'config';
import moment from 'moment'

export const GET_COURSE_LESSONS = '[INSTRUCTOR APP] GET COURSE LESSONS';
export const ADD_COURSE_TO_SCHEDULE = '[INSTRUCTOR APP] ADD COURSE TO SCHEDULE';
export const ADD_MODULE_TO_SCHEDULE = '[INSTRUCTOR APP] ADD MODULE TO SCHEDULE';
export const MOVE_LESSON = '[INSTRUCTOR APP] MOVE LESSON';
export const GET_COURSE_PREVIEW = '[INSTRUCTOR APP] GET COURSE PREVIEW';
export const GET_MODULE_PREVIEW = '[INSTRUCTOR APP] GET MODULE PREVIEW';
export const GET_SAVED_EVENTS = '[INSTRUCTOR APP] GET EVENTS';
export const GET_DAY_EVENTS = '[INSTRUCTOR APP] GET DAY EVENTS';
export const CHECK_LESSON_OVERWRITE = '[INSTRUCTOR APP] CHECK LESSON OVERWRITE';
export const HANDLE_EVENT_SELECT = '[INSTRUCTOR APP] HANDLE EVENT SELECT';

export function getCourseLessons(course_id, instructor_id, startDate) {

    return (dispatch) => {
        return fetch(server_connection + '/course/schedule/' + course_id)
            .then((response) => response.json())
            .then((lessons) => {
                dispatch(addCourseToSchedule(course_id, instructor_id, startDate, lessons))
            })
    }
}

export function addCourseToSchedule(course_id, instructor_id, startDate) {
    return (dispatch) => {
        fetch(server_connection + '/instructor/schedule/course',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ course_id: course_id, instructor_id: instructor_id, startDate: startDate })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch(getEvents(instructor_id, startDate.getMonth(), startDate.getFullYear()));
            });
    }
}

export function addModuleToSchedule(module_id, instructor_id, startDate) {
    return (dispatch) => {
        fetch(server_connection + '/instructor/schedule/module',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ module_id: module_id, instructor_id: instructor_id, startDate: startDate })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch(getEvents(instructor_id, startDate.getMonth(), startDate.getFullYear()));
            });
    }
}

export function addLessonToSchedule(lesson_id, instructor_id, startDate) {
    return (dispatch) => {
        fetch(server_connection + '/instructor/schedule/lesson',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ lesson_id: lesson_id, instructor_id: instructor_id, startDate: startDate })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch(getEvents(instructor_id, startDate.getMonth(), startDate.getFullYear()));
            });
    }
}

export function moveLesson(event, start, instructor_id) {
    return (dispatch) => {
        fetch(server_connection + '/instructor/schedule/move_lesson',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ event: event, start: start, instructor_id: instructor_id })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch(getEvents(instructor_id, event.start.getMonth(), event.start.getFullYear()));
            });
    }
}

export function overwriteLesson(instructor_id, actionType, newLesson, oldLesson) {
    return (dispatch) => {
        fetch(server_connection + '/instructor/schedule/overwrite_lesson',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({
                    instructor_id: instructor_id,
                    actionType: actionType,
                    newLesson: newLesson,
                    oldLesson: oldLesson,
                })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch(getEvents(instructor_id, newLesson.start.getMonth(), newLesson.start.getFullYear()));
            });
    }
}

export function checkLessonOverwrite(newEvent, oldEvent, date) {
    return {
        type: CHECK_LESSON_OVERWRITE,
        payload: { newEvent: newEvent, oldEvent: oldEvent, date: date }
    }
}


export function getCoursePreview(course_id) {
    return (dispatch) => {
        return fetch(server_connection + '/course/schedule/' + course_id)
            .then((response) => response.json())
            .then((lessons) => {
                dispatch({
                    type: GET_COURSE_PREVIEW,
                    payload: { lessons: lessons, course_id: course_id }
                })
            })
    }
}

export function getModulePreview(module_id) {
    return (dispatch) => {
        return fetch(server_connection + '/module/get_lessons/' + module_id)
            .then((response) => response.json())
            .then((lessons) => {
                dispatch({
                    type: GET_MODULE_PREVIEW,
                    payload: {
                        module_id: module_id,
                        lessons: lessons
                    }
                })
            })
    }
}

export function getEvents(instructor_id, month, year) {
    return async (dispatch) => {
        return await fetch(server_connection + '/instructor/schedule/' + instructor_id + '/' + month + '/' + year)
            .then((response) => response.json())
            .then((lessons) => {
                dispatch({
                    type: GET_SAVED_EVENTS,
                    payload: lessons
                })
            })
    }
}

export function getDayEvents(instructor_id, date) {
    return async (dispatch) => {
        return await fetch(server_connection + '/instructor/day/' + instructor_id + '/' + date)
            .then((response) => response.json())
            .then((events) => {
                dispatch({
                    type: GET_DAY_EVENTS,
                    payload: events
                })
            })
    }
}

export function handleEventSelect(lesson_id, module_id, course_id) {
    return {
        type: HANDLE_EVENT_SELECT,
        payload: { lesson_id: lesson_id, module_id: module_id, course_id: course_id }
    }
}

export function deleteCourseFromSchedule(instructor_id, instructor_calendar_course_id, event) {
    return (dispatch, getState) => {
        fetch(server_connection + '/instructor/schedule/delete/course',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ instructor_id: instructor_id, instructor_calendar_course_id: instructor_calendar_course_id })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch(getEvents(instructor_id, event.start.getMonth(), event.start.getFullYear()));
            });
    }
}

export function resizeDayEvent(event, instructor_id) {
    return (dispatch) => {
        fetch(server_connection + '/instructor/schedule/resize_day_event',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ event: event})
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch(getDayEvents(instructor_id, moment(new Date(event.start)).format('YYYY-MM-DD')));
            });
    }
}



// WEBPACK FOOTER //
// src/main/content/instructor/store/actions/calendar.actions.js